// Sign-in page.
// - Firebase mode (prod): "Sign in with Google" button via popup.
// - Stub mode (dev): the original player picker.

import { useState } from "react";
import type { State } from "../state";
import { Avatar } from "../components/Avatar";
import { FootballIcon } from "../components/FootballIcon";
import { firebaseEnabled, signInWithGoogle, signOutUser } from "../firebase";

export function Login({
  onStubLogin,
  state,
  authError,
}: {
  onStubLogin: (id: string) => void;
  state: State;
  authError: string | null;
}) {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (firebaseEnabled()) {
    return (
      <div className="login">
        <div className="login__ball"><FootballIcon /></div>
        <h1>DSK PickEm - Daily</h1>
        <p>Your group. Your calls. Entirely reasonable levels of bragging.</p>
        <p style={{ fontSize: 11, color: "var(--ink-dim)", marginTop: -8 }}>
          Tip: if you came here from WhatsApp, iMessage, or Instagram — tap the link and choose <strong>"Open in browser"</strong> (Chrome / Safari) first. In-app browsers block sign-in.
        </p>
        {(authError || error) && (
          <div className="error">
            {authError || error}
            {authError && (
              <button
                style={{ marginTop: 8, background: "none", border: "none", color: "var(--brand)", textDecoration: "underline", cursor: "pointer" }}
                onClick={() => { signOutUser(); setError(null); }}
              >
                Sign out and try another account
              </button>
            )}
          </div>
        )}
        <button
          disabled={busy}
          onClick={async () => {
            setError(null);
            setBusy(true);
            try {
              await signInWithGoogle();
            } catch (e: unknown) {
              setError(e instanceof Error ? e.message : "Sign-in failed");
            } finally {
              setBusy(false);
            }
          }}
          style={{ background: "var(--card)", border: "var(--border)", borderRadius: 10, padding: "12px 16px", display: "flex", alignItems: "center", gap: 8, justifyContent: "center", fontSize: 14 }}
        >
          {busy ? "Walking onto the pitch…" : "Join with Google"}
        </button>
      </div>
    );
  }

  // Stub mode (dev)
  return (
    <div className="login">
      <div className="login__ball"><FootballIcon /></div>
      <h1>DSK PickEm - Daily</h1>
      <p>Dev tunnel — choose your player card.</p>
      {error && <div className="error">{error}</div>}
      <div className="player-list">
        {state.players.map((p) => (
          <button key={p.id} onClick={() => onStubLogin(p.id)}>
            <Avatar name={p.name} initials={p.initials} color={p.color} size="sm" />
            <span>{p.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
